import script from "./ProjectAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddWorkerDropdown.vue?vue&type=style&index=0&id=94bcbafc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94bcbafc"]])

export default __exports__